import { render, staticRenderFns } from "./CustomIconDatePicker.vue?vue&type=template&id=5c2d34c8&scoped=true&"
import script from "./CustomIconDatePicker.vue?vue&type=script&lang=js&"
export * from "./CustomIconDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./CustomIconDatePicker.vue?vue&type=style&index=0&id=5c2d34c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d34c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VDialog,VIcon,VSpacer})
